"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityAudit = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const date_fns_1 = require("date-fns");
const react_1 = __importDefault(require("react"));
const useAuditTable_1 = require("../hooks/useAuditTable");
const AuditDetailsDialog_1 = require("./AuditDetailsDialog");
const EntityAudit = (props) => {
    const filter = react_1.default.useMemo(() => {
        const now = Date.now();
        return {
            dateRange: {
                from: (0, date_fns_1.formatISO)((0, date_fns_1.sub)(now, { months: 1 }), { representation: 'date' }),
                to: (0, date_fns_1.formatISO)(now, { representation: 'date' }),
            },
        };
    }, []);
    const { dataTableProps, clearActiveRow } = (0, useAuditTable_1.useAuditTable)({
        useDataTableFunction: DataTable_1.useDataTableUsingState,
        entityIds: props.entityIds,
        eventTypes: props.eventTypes,
        additionalEventTypes: props.additionalEventTypes,
        entities: props.entities,
        includeRelatedEntities: props.includeRelatedEntities,
        initialFilterData: filter,
        customAuditBackendDataProvider: props.customAuditBackendDataProvider,
        auditTags: props.auditTags,
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DataTable_1.DataTable, Object.assign({}, dataTableProps)),
        dataTableProps.activeRowId && (react_1.default.createElement(AuditDetailsDialog_1.AuditDetailsDialog, { id: dataTableProps.activeRowId, onClose: clearActiveRow, formatters: props.formatters }))));
};
exports.EntityAudit = EntityAudit;
